import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'

const supportedLocales = ['en', 'en-IE', 'en-SG', 'en-GB'];

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {},
    silentFallbackWarn: true
});

i18n.loadLocaleMessagesAsync = function (apiControllerUrl, localesToLoad) {
    if ((typeof localesToLoad == 'undefined') || (localesToLoad == null)) {
        localesToLoad = supportedLocales;
    }
    if (!localesToLoad.includes(this.fallbackLocale)) {
        localesToLoad.push(this.fallbackLocale);
    }
    localesToLoad.forEach(locale => {
        var url = apiControllerUrl;
        if (!url.endsWith('/'))
            url += '/';
        url += 'i18n-messages/';
        url += locale;
        axios
            .get(url)
            .then(response => {
                this.setLocaleMessage(locale, response.data);
            });
    });
}

export default i18n;
